<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("resellers.tabs.errors") }}
  UiCardSection
    RestTable(
      namespace="resellerErrors"
      :headers="headers"
      ref="resellerErrorsTable"
      :fetch-handler="getData"
      embed
    )
</template>

<script>
import router from "@/router";
import ApiResellers from "@/api/resellers.js";

export default {
  data() {
    return {
      headers: [
        {
          key: "company",
          label: "Company",
          sortable: false,
        },
        {
          key: "software",
          label: "Software",
          sortable: false,
        },
        {
          key: "error",
          label: "Error",
          sortable: false,
        },
        {
          key: "created",
          label: "#",
          sortable: false,
        },
      ],
    };
  },

  methods: {
    getData(params, config) {
      return ApiResellers.fetchResellerErrors(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.reseller_errors,
          meta: resp.data.meta,
        };
      });
    },
    goBack() {
      router.push("/resellers");
    },
  },
};
</script>
